import { AfterContentInit, Component } from "@angular/core";
import { FormularGroupTabContentComponent } from "../tab-content.interface";
import {
  FormularDynamicFieldsCategory,
  FormularGroupDynamicFields,
  FieldInputType,
  FormularDynamicFieldsField,
  FormularDynamicFieldsGroup,
} from "../../../formular-model/formular-groups/interfaces/FormularGroupDynamicFields";
import { CommonKeys } from "../../../formular-model/common/enums";
import { FormGroup, FormArray, FormControl } from "@angular/forms";

@Component({
  selector: "formular-group-tab-dynamic-fields",
  templateUrl: "./dynamicfields.component.html",
  styleUrls: ["./dynamicfields.component.scss"],
  standalone: false,
})
export class FormularGroupTabDynamicFieldsComponent
  extends FormularGroupTabContentComponent<FormularGroupDynamicFields>
  implements AfterContentInit
{
  override formularGroupDataKey = "Categories";

  get controls() {
    return this.form.controls;
  }
  get categories(): FormularDynamicFieldsCategory[] {
    return this.data[this.formularGroupDataKey][CommonKeys.Values];
  }
  get internalValues(): FormularDynamicFieldsCategory[] {
    return this.__dataInternal[this.formularGroupDataKey][CommonKeys.Values];
  }

  getGroups(
    category: FormularDynamicFieldsCategory,
  ): FormularDynamicFieldsGroup[] {
    return category["Groups"][CommonKeys.Values];
  }

  getFields(group: FormularDynamicFieldsGroup): FormularDynamicFieldsField[] {
    return group["Fields"][CommonKeys.Values];
  }

  getInputType(type: number) {
    const res = FieldInputType[type];
    return res ? res : "text";
  }

  getCategoryByIndex(i: number): FormularDynamicFieldsCategory {
    return this.categories[i];
  }

  hasFields(
    category: FormularDynamicFieldsCategory | FormularDynamicFieldsGroup,
  ): boolean {
    return (
      "Fields" in category && category["Fields"][CommonKeys.Values].length > 0
    );
  }

  hasGroups(category: FormularDynamicFieldsCategory): boolean {
    return (
      "Groups" in category && category["Groups"][CommonKeys.Values].length > 0
    );
  }

  getCtl(
    categoryIndex: number,
    groupsOrFieldsIndex: number,
    groupFieldIndex?: number,
  ) {
    let fieldCtl: FormControl;

    if (groupFieldIndex !== null) {
      const categoryCtlGroup = (this.form.get("Categories") as FormArray)
        .controls[categoryIndex] as FormGroup;
      const categoryGroupCtlArray = (
        categoryCtlGroup.get("Groups") as FormArray
      ).controls[groupsOrFieldsIndex] as FormArray;
      fieldCtl = categoryGroupCtlArray.controls[groupFieldIndex] as FormControl;
    } else {
      const categoryCtlGroup = (this.form.get("Categories") as FormArray)
        .controls[categoryIndex] as FormGroup;
      fieldCtl = (categoryCtlGroup.get("Fields") as FormArray).controls[
        groupsOrFieldsIndex
      ] as FormControl;
    }

    return fieldCtl;
  }

  ngAfterContentInit(): void {
    this.__dataInternal = { ...this.data };

    const categoriesCtlArray = new FormArray([]);
    this.form.addControl("Categories", categoriesCtlArray);

    this.categories.forEach((category) => {
      const categoryCtlGroup = new FormGroup({});
      categoriesCtlArray.push(categoryCtlGroup);

      if (
        "Groups" in category &&
        category["Groups"][CommonKeys.Values].length > 0
      ) {
        const categoryGroupsCtlArray = new FormArray([]);
        categoryCtlGroup.addControl("Groups", categoryGroupsCtlArray);

        category["Groups"][CommonKeys.Values].forEach((group) => {
          const groupFieldsCtlArray = new FormArray([]);
          categoryGroupsCtlArray.push(groupFieldsCtlArray);

          group["Fields"][CommonKeys.Values].forEach((field) => {
            groupFieldsCtlArray.push(new FormControl(field[CommonKeys.Value]));
          });
        });
      }

      if (
        "Fields" in category &&
        category["Fields"][CommonKeys.Values].length > 0
      ) {
        const categoryFieldsCtlArray = new FormArray([]);
        categoryCtlGroup.addControl("Fields", categoryFieldsCtlArray);

        category["Fields"][CommonKeys.Values].forEach((field) => {
          categoryFieldsCtlArray.push(new FormControl(field[CommonKeys.Value]));
        });
      }
    });
  }

  reconstructData() {
    for (let ci = 0; ci < this.internalValues.length; ci++) {
      const category = this.internalValues[ci];

      if (this.hasGroups(category)) {
        for (
          let gi = 0;
          gi < category["Groups"][CommonKeys.Values].length;
          gi++
        ) {
          const group = category["Groups"][CommonKeys.Values][gi];

          if (this.hasFields(group)) {
            for (
              let fi = 0;
              fi < group["Fields"][CommonKeys.Values].length;
              fi++
            ) {
              const ctl = this.getCtl(ci, gi, fi);
              const field = group["Fields"][CommonKeys.Values][fi];

              field[CommonKeys.Value] = ctl.value || null;
            }
          }
        }
      }
    }

    return this.__dataInternal;
  }
}

/*
Categories: FormArray | FormularGroup['Categories']['$values']: {}[]
L_Groups?: FormArray | FormularGroup['Categories']['$values']['Groups']['$values']: {}[]
  L_0: FormArray | FormularGroup['Categories']['$values']['Groups']['$values']['Fields']['$values']: {}[]
       L_0: FormControl
       L_...
  L_1: FormGroup | ...
  L_...
L_Fields?: FormArray | FormularGroup['Categories']['$values']['Fields']['$values']: {}[]
  L_0: FormControl
  L_...

(FormGroup)form: {
    (FormArray)Categories: [ -------- categoriesCtlArray
        (FormArray<-Groups[i])[ ------- categories.forEach(c)
            (FormArray<-Groups[i].Fields[j])[
                FormControl(), ...
            ],
            ...
        ],
        (FormArray<-Fields[i])[
            FormControl(), ...
        ]
    ]
}
*/
